var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7568 4H10.1395C9.17828 4 8.39624 4.79441 8.39624 5.77082V5.98816H7.24326C6.28205 5.98816 5.5 6.78257 5.5 7.75898V18.2292C5.5 19.2056 6.28205 20 7.24326 20H13.8606C14.8218 20 15.6038 19.2056 15.6038 18.2292V18.0118H16.7567C17.718 18.0118 18.5 17.2174 18.5 16.241V5.77082C18.5001 4.79441 17.718 4 16.7568 4ZM14.4794 18.2292C14.4794 18.5757 14.2018 18.8577 13.8607 18.8577H7.24326C6.90209 18.8577 6.62449 18.5757 6.62449 18.2292V7.7589C6.62449 7.41234 6.90209 7.13035 7.24326 7.13035H13.8606C14.2017 7.13035 14.4793 7.41234 14.4793 7.7589V18.2292H14.4794ZM17.3756 16.241C17.3756 16.5876 17.098 16.8696 16.7568 16.8696H15.6038V7.7589C15.6038 6.78249 14.8218 5.98808 13.8607 5.98808H9.52073V5.77075C9.52073 5.42418 9.79832 5.14219 10.1395 5.14219H16.7568C17.098 5.14219 17.3756 5.42418 17.3756 5.77075V16.241Z",
    fill: "#C6CCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.ca26644c921015c1e330c07d82be25ec.svg";
export { ForwardRef as ReactComponent };